var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "input-group position:relative" }, [
    _c("input", {
      directives: [
        {
          name: "model",
          rawName: "v-model",
          value: _vm.inputText,
          expression: "inputText"
        }
      ],
      staticClass: "form-control",
      attrs: { type: "text", placeholder: "search" },
      domProps: { value: _vm.inputText },
      on: {
        keydown: [
          function($event) {
            if (
              !("button" in $event) &&
              _vm._k($event.keyCode, "enter", 13, $event.key)
            ) {
              return null
            }
            _vm.enter($event)
          },
          function($event) {
            if (
              !("button" in $event) &&
              _vm._k($event.keyCode, "down", 40, $event.key)
            ) {
              return null
            }
            _vm.down($event)
          },
          function($event) {
            if (
              !("button" in $event) &&
              _vm._k($event.keyCode, "up", 38, $event.key)
            ) {
              return null
            }
            _vm.up($event)
          }
        ],
        focus: _vm.onFocus,
        blur: _vm.onBlur,
        input: function($event) {
          if ($event.target.composing) {
            return
          }
          _vm.inputText = $event.target.value
        }
      }
    }),
    _vm._v(" "),
    _c(
      "ul",
      {
        staticClass: "dropdown-menu px-2",
        class: { "dropdown-show": _vm.active }
      },
      _vm._l(_vm.matches, function(suggestion, index) {
        return _c(
          "li",
          {
            key: index,
            class: { selected: _vm.isActive(index) },
            on: {
              click: function($event) {
                _vm.suggestionClick($event, suggestion)
              }
            }
          },
          [
            _vm._v(
              " " + _vm._s(suggestion[_vm.nameField]) + " \r\n            "
            )
          ]
        )
      })
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0eb5a1f8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0eb5a1f8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Autocomplete.vue
// module id = null
// module chunks = 